export default __webpack_public_path__ + "images/pictograms/firefox.svg?0264dc45ff6e6b4662e3c6a6819c4f3cbc251cd78e4eaf899391c95316231847";